module.exports = __webpack_public_path__ + "img/logo_coastal.2ea8c24e.png";